module.exports = __webpack_public_path__ + "img/4.5b1c8856.jpg";